import styled from 'styled-components';

export const ColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const LabelBlock = styled.div`
  display: block;
  margin-bottom: 0;
  line-height: 1.2;
`;

export const LabelRowTop = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

export const LabelRowBottom = styled.div`
  display: flex;
  justify-content: normal;
  align-items: baseline;
  width: 100%;
  gap: 8px;
`;

export const ViewOrdersLink = styled.button`
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font-size: 10px;
  color: #278ada;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    color: #1a6bb8;
  }
`;

export const QuantityLabel = styled.label`
  display: block;
  margin-bottom: 0;
`;

export const ModalContent = styled.div`
  margin: 0;
  padding: 0;
`;

export const OrdersTableWrapper = styled.div`
  margin: 0;
  padding: 0;
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const OrdersTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #e5e8e9;
    text-align: left;
    vertical-align: top;
    padding: 0 12px 8px 0;
    border-bottom: 1px solid #d8d8d8;
    font-size: 12px;
    font-weight: 600;
    color: #278ada;
    white-space: nowrap;
    line-height: 1.2;
  }

  thead th:first-child {
    padding-left: 0;
  }

  tbody tr {
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #eeeeee;
    }

    &.is-past td:nth-child(1),
    &.is-past td:nth-child(4),
    &.is-past td:nth-child(2) {
      text-decoration: line-through;
      color: #888;
    }
  }

  tbody td {
    text-align: left;
    vertical-align: top;
    padding: 10px 12px 10px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 12px;
    color: #333;
    line-height: 1.3;
  }

  tbody td:first-child {
    padding-left: 0;
  }

  thead th:nth-child(2),
  tbody td:nth-child(2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  thead th:nth-child(3),
  tbody td:nth-child(3) {
    padding-right: 16px;
  }

  thead th:nth-child(4),
  tbody td:nth-child(4) {
    padding-right: 16px;
    text-align: right;
  }

  thead th:nth-child(5),
  tbody td:nth-child(5) {
    padding-left: 8px;
  }

  col.token {
    width: 14%;
  }

  col.name {
    width: 28%;
  }

  col.date {
    width: 22%;
  }

  col.quantity {
    width: 16%;
  }

  col.status {
    width: 20%;
  }
`;

export const EmptyState = styled.p`
  margin: 0;
  font-size: 12px;
  color: #666;
`;
